import { render } from "./TipsTable.vue?vue&type=template&id=783585d2&scoped=true"
import script from "./TipsTable.vue?vue&type=script&lang=js"
export * from "./TipsTable.vue?vue&type=script&lang=js"

import "./TipsTable.vue?vue&type=style&index=0&id=783585d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-783585d2"

export default script